export default function searchPopup () {
    const searchWrapper = document.querySelector('.header .search');
    const searchPopup = document.querySelector('.header .search-popup');
    const crossIcon = document.querySelector('.header .search-popup .cross-icon');

    if (searchWrapper && searchPopup && crossIcon) {
        searchWrapper.addEventListener('click', function () {
            searchPopup.classList.add('open');
        });

        crossIcon.addEventListener('click', function () {
            searchPopup.classList.remove('open');
        });

        document.addEventListener('keydown', function (event) {
            if (event.key === 'Escape') {
                searchPopup.classList.remove('open');
            }
        });
    }
};